var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":_vm.$t('reservation_percentage')}},[_c('a-rms-revenue-reservation-percentage-chart',{attrs:{"labels":_vm.chart_data.labels,"series":_vm.chart_data.values}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }